import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { selectOffices } from '@features/desks/store/advanceHotDeskingSetup.duck';
import { BodyLarge, BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { OfficeEntity } from '@features/desks/services/AdvanceHotDeskingService';
import { NoSetup } from "./NoSetup";
import Colours from '@shared/ui/atoms/Colours';
import { MountedContentCard, MountedContentCardContent } from '@shared/ui/atoms/MountedContentCard';
import { SpaceBetweenRow } from "../../StyleComponents";
import { Column, Row } from '@shared/ui/atoms/StructuralLayout';
import { smallTablet } from '@shared/ui/atoms/MediaQueries';
import { SecondaryButton } from '@shared/ui/atoms/buttons/SecondaryButton';
import styled from "styled-components";
import { CapacityResponse, getOfficeCapacity } from '@features/desks/services/OfficeCapacityService';
import moment from "moment";
import { useTranslation } from "react-i18next";
import { iconPackPath } from '@shared/utils/WhereaboutsHelper';
import { FreeBusyStatus } from '@features/whereabouts/services/WhereaboutOptions';
import { selectIconPack } from "@shared/store/auth.duck";
import { IconPack } from '@shared/models/company.models';
import { WithOfficeCapacity } from '@shared/ui/organisms/weekly-movements-setter/hooks/WithCapacity';
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export function OfficeList() {
  const rootOffices = useSelector(selectOffices);
  const iconPack = useSelector(selectIconPack);

  return (
    <div style={{marginBottom: 16}}>
      {(!rootOffices) && <NoSetup/>}
      {rootOffices.map((office: OfficeEntity, key: number) => (
        <OfficeElement office={office} iconPack={iconPack} key={key} />
      ))}
    </div>
  )
}


function OfficeElement (props: {office: OfficeEntity, iconPack: IconPack}) {
  const {office, iconPack} = props;
  const [officeCapacity, setOfficeCapacity] = useState<CapacityResponse | undefined>();
  const {t} = useTranslation();

  useEffect(() => {
    if (office.capacityEnabled) {
      getOfficeCapacity(office.id, moment())
        .then(resp => setOfficeCapacity(resp));
    }
  }, [office]);

  const officeUsage = WithOfficeCapacity(officeCapacity);

  return (
    <OfficeContentCard className="contentCard__office">

      <MountedContentCardContent>
        <SpaceBetweenRow>
          <Row style={{alignItems: 'flex-start', marginBottom: 10}}>
            <OfficeImage src={iconPackPath(iconPack, 'Office.svg', FreeBusyStatus.FREE)} alt="Office image"/>
            <Column>
              <BodyLarge weight={600}>{office.label}</BodyLarge>
              {office.capacityEnabled && <BodyRegular weight={600} colour={Colours.blue} style={{marginBottom: 10}}>{t('whereabouts.seats-available', {remaining: officeUsage})}</BodyRegular>}
              <BodyRegular weight={400}>{office.postCode}</BodyRegular>
            </Column>
          </Row>
        </SpaceBetweenRow>
        <SecondaryButton fullWidth={true}
                         size={ButtonSize.Large}
                         text="button.edit-office"
                         dataTest={`edit-office-${office.label}`}
                         click={() => window.location.href=`/manage/offices/${office.id}`}/>
      </MountedContentCardContent>

    </OfficeContentCard>
  )
}

const OfficeImage = styled.img`
  width: 80px;
  height: 80px;
  margin-right: 8px;
`


const OfficeContentCard = styled(MountedContentCard)<any>`
  margin-bottom: 16px;
  padding: 24px;
  display: flex;
  justify-content: center;
  border: 1px solid ${Colours.mildGrey};
  border-radius: 8px;
  @media (${smallTablet}) {
    padding: 48px;
  }
`
